import { render, staticRenderFns } from "./MemoPathForm.vue?vue&type=template&id=cbb4b54a&"
import script from "./MemoPathForm.vue?vue&type=script&lang=js&"
export * from "./MemoPathForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports